/**
 * UI控件库 
 * @module Core
 */

;(function (ui,$) {
    
    /*
     * touch 滑动控制器,给控件使用的,不是单独的控件
     * @namespace  bui
     * @class  touch
     * @param {string} id [滑动的选择器]
     * @param {string} [handle] [子元素]
     * @param {boolean} [useCapture] [事件捕获,可以用来阻止底层事件触发]
     * @param {function} [onStart] [滑动开始,返回 e,touch]
     * @param {function} [onMove] [滑动中,返回 e,touch]
     * @param {function} [onEnd] [滑动结束,返回 e,touch]
     * @constructor 
     * @example
     *
        
         //滑动控制器
         var uiTouch = bui.touch({
            id: "#page",
            onStart: function(e,touch){

            },
            onMove: function(e,touch){

            },
            onEnd: function(e,touch){

            }
         })
     *
     */
    ui.touch = function (option) {
        var config = {
            id: "",
            handle: "",
            useCapture: false,
            onStart: null,
            onMove: null,
            onEnd: null
        };
        var param = $.extend(true,{}, config, option);

        var module = {
            on: on,
            off: off,
            move: move
        }

        //滑动兼容处理
        var isTouchPad = (/hp-tablet/gi).test(navigator.appVersion),
            hasTouch = 'ontouchstart' in window && !isTouchPad, 
            direction = "",
            lastY = 0,
            lastX = 0,
            isOnStart = false,//解决PC一直触发mousemove事件
            touch = {
                x1:0,
                x2:0,
                y1:0,
                y2:0,
                direction:""
            };

        var $id = ui.obj(param.id);

        var el = param.handle ? $id.find(param.handle): $id;

        var useCapture = param.useCapture;

        //开始拖动
        function onstart(e) {

            var point = hasTouch ? e.touches[0]: e;
                touch.x1 = point.pageX;
                touch.y1 = point.pageY;
                touch.direction = "";

                //解决PC一直触发mousemove事件
                isOnStart = true;

                //开始的时候计算
                param.onStart && param.onStart.call(this,e,touch);

        }

        //拖动中
        function onmove (e) {
            //解决PC一直触发mousemove事件
            if( !isOnStart ){
                return;
            }
            var point = hasTouch ? e.touches[0]: e;
                touch.x2 = point.pageX;
                touch.y2 = point.pageY;
            //第一次下拉的方向
            if( !touch.direction){
                //方向
                touch.direction = ui.swipeDirection(touch.x1,touch.x2,touch.y1,touch.y2);
            }

            //阻止默认事件,除了滚动条,解决红米不触发end问题
            if( touch.direction === "swipeLeft" || touch.direction === "swipeRight" ){
               e.preventDefault();
            }

            //移动过程中计算
            if(touch.direction){
              param.onMove && param.onMove.call(this,e,touch);
            }

        }

        //拖动结束
        function onend (e) {
            //保存最后的位置
            lastY = lastY + (touch.y2-touch.y1);
            lastX = lastX + (touch.x2-touch.x1);

            touch.lastX = lastX;
            touch.lastY = lastY;

            //结束以后执行
            param.onEnd && param.onEnd.call(this,e,touch);

            count = 0;
            //清空滑动缓存
            touch = {
                x1:0,
                x2:0,
                y1:0,
                y2:0,
                direction:""
            };

            isOnStart = false;
        }

        /**
         *  解绑事件
         *  @method off
         *  @param {string} [events] [事件: touchstart | touchmove | touchend ]
         *  @param {object} [ele] [ 绑定的DOM对象 ]
         *  @chainable
         *  @example 
            
            //解绑所有事件
            uiTouch.off();
                
         */
        function off(events,ele) {
            var ele = ele || el;
            switch(events){
                case "touchstart":
                ui.off(events,ele, onstart ,useCapture);
                break;
                case "touchmove":
                ui.off(events,ele, onmove ,useCapture);
                break;
                case "touchend":
                ui.off(events,ele, onend ,useCapture);
                break;
                default:
                ui.off("touchstart",ele, onstart ,useCapture);
                ui.off("touchmove",ele, onmove ,useCapture);
                ui.off("touchend",ele, onend ,useCapture);
            }
        };

        /**
         *  绑定滑动事件
         *  @method on
         *  @param {string} [events] [事件: touchstart | touchmove | touchend ]
         *  @param {object} [ele] [ 绑定的DOM对象 ]
         *  @chainable
         *  @example 
            
            //绑定滑动事件
            uiTouch.on();
                
         */
        function on(events,ele) {
            var ele = ele || el;

            switch(events){
                case "touchstart":
                ui.on(events,ele, onstart ,useCapture);
                break;
                case "touchmove":

                ui.on(events,ele, onmove ,useCapture);
                break;
                case "touchend":

                ui.on(events,ele, onend ,useCapture);
                break;
                default:

                ui.on("touchstart",ele, onstart ,useCapture);
                ui.on("touchmove",ele, onmove ,useCapture);
                ui.on("touchend",ele, onend ,useCapture);
            }
        };

        
        /**
         *  对象的移动
         *  @method move
         *  @param {string} [x] [水平移动 ]
         *  @param {string} [y] [纵向移动 ]
         *  @param {string} [transition] [ 位移动画执行结束的时间,默认300ms, 单位ms 不用动画时, 传"none" ]
         *  @param {object} [ele] [ 移动的jQuery对象 ]
         *  @chainable
         *  @example 
            
            //绑定滑动事件
            uiTouch.move("20px",0);
                
         */
        function move(x,y,transition,ele) {

            var transition,
                ele = ele || $id, //jquery 对象
                x = x || 0,
                y = y || 0;
            if( typeof transition === "number"){
              transition = "all "+transition+"ms";
            }else {
              transition = transition || "all 300ms";
            }

            // translateZ(0) 会导致中兴z802t 的下拉一次,上拉滚动加载只请求一次失效
            ele.css({
                "-webkit-transition":transition,
                "transition":transition,
                "-webkit-transform": "translate("+x+","+y+")",
                "transform": "translate("+x+","+y+")"
            });
        };

        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 toggle ]
         *  @example 
            
            //获取依赖控件
            var uiTouchWidget = uiTouch.widget();
            
                
         */
        function widget(name) {
            var control = { };
            return ui.widget.call(control,name);
        };

        function init() {
            // 绑定事件
            on();
        }
        //事件初始化
        init();


        return module;
    }


    return ui;

})( bui || {}, libs );
